const getWorkflowDataView = async ({ commit, rootGetters, dispatch }, { storageId }) => {
  commit('SET_WORKFLOW_DATA_VIEW_LOADING', true);
  try {
    const customer = rootGetters['customer/CUSTOMER'];
    const selected_customer = rootGetters['customer/SELECTED_CUSTOMER'];

    let url = `/proxy/data-view-rows`;

    let customer_id = customer.customer_id;

    if (customer_id === 0) {
      customer_id = selected_customer.customer_id;
    }

    const data = {
      customer_id,
      storage_id: storageId,
    };

    const response = await window.axios.get(url+`?customer_id=${customer_id}&storage_id=${storageId}`, data);

    if (response && response.data) {
        commit('SET_WORKFLOW_DATA_VIEW', response.data);
    } else {
      throw response.data;
    }
  } catch (error) {
    dispatch('notifications/setError', error.message, { root: true });
  } finally {
    commit('SET_WORKFLOW_DATA_VIEW_LOADING', false);
  }
};

export default getWorkflowDataView;
